import { INavMenuItem } from "@app/nav/nav.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";


export const navAdapter: EntityAdapter<INavMenuItem> = createEntityAdapter<INavMenuItem>({
	selectId: nav => nav.id
});